import { render } from "./WorkstationSettingView.vue?vue&type=template&id=4897fd1c&scoped=true&ts=true"
import script from "./WorkstationSettingView.vue?vue&type=script&lang=ts"
export * from "./WorkstationSettingView.vue?vue&type=script&lang=ts"

import "./WorkstationSettingView.vue?vue&type=style&index=0&id=4897fd1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4897fd1c"]])

export default __exports__